module.exports = __webpack_public_path__ + "case-studies.cebfccf4caae5c94b12300ff356e57e1.png";